import { AppFile, AppFileDataExt } from 'globales-projekt-angular'; 
import { DateiTyp } from 'src/app/immutable/enums/datei-typ';
import { ApiService } from 'src/app/services/api.service';
import { LocalService } from 'src/app/services/local.service';

export class FileAppMetaDatas {
  winddatenCsv: AppFileDataExt = new AppFileDataExt();
  vdiAuszugPdf: AppFileDataExt = new AppFileDataExt();


  constructor(private localService: LocalService, private apiService: ApiService) {}

  loadFileAppMetaDatas() { 
    this.localService.mainComponentRef.value?.waitingForDataSpinner(true);
    this.apiService.getAppFileSizeDocuments().subscribe((response) => {
      let appFileList: AppFile[] = response;

      for (let entry of appFileList) {
        let appFileDataExt: AppFileDataExt = new AppFileDataExt(entry);

        if (appFileDataExt.idTyp == DateiTyp.WINDDATEN_CSV) {
          this.winddatenCsv = appFileDataExt;
        } 
        if (appFileDataExt.idTyp == DateiTyp.VDI_AUSZUG_PDF) {
          this.vdiAuszugPdf = appFileDataExt;
        }
      }

      this.localService.mainComponentRef.value?.waitingForDataSpinner(false);
    });
  }
}
